import { CommonModule } from '@angular/common';
import { Component, OnInit, Inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { HeaderComponent as GbHeaderComponent } from '@bookinglab/govbook-ui/layout';
import {
  ImageDetail,
  NavLink,
} from '@bookinglab/govbook-ui/layout/lib/util/model';
@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss'],
	standalone: true,
	imports: [CommonModule, GbHeaderComponent, MatIconModule],
})
export class HeaderComponent {
	goToWebsite() {
		window.open('https://www.havering.gov.uk/', '_blank', 'noopener,noreferrer');
	}

	imageDetail: ImageDetail = {
		alt: 'London Borough of Havering information on births, deaths and marriages',
		src: 'assets/havering_logo.png',
		href: 'https://www.havering.gov.uk/births-deaths-marriages',
	};

	navigation: NavLink[] = [
		{
			text: 'Sign in',
			url: 'https://havering-self.achieveservice.com/',
		},
	];

	search(term: string) {
		const formatted = term.trim().replace(/\s+/g, '+');
		const url = `https://www.havering.gov.uk/site-search/results/?q=${formatted}`;
		window.location.href = url;
	}
}
